var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.0343 0L33.5889 18.755L37.9431 7.69L57.0343 0Z",
    fill: "#E17726"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96582 0L26.1979 18.9325L22.0569 7.69L2.96582 0Z",
    fill: "#E27625"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6071 43.4775L42.3701 53.7825L55.7158 57.74L59.5299 43.705L48.6071 43.4775Z",
    fill: "#E27625"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.494141 43.705L4.28501 57.74L17.6307 53.7825L11.4169 43.4775L0.494141 43.705Z",
    fill: "#E27625"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8997 26.065L13.1807 32.1325L26.4104 32.7675L25.9629 17.41L16.8997 26.065Z",
    fill: "#E27625"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0996 26.065L33.8949 17.2325L33.5889 32.7675L46.8186 32.1325L43.0996 26.065Z",
    fill: "#E27625"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6299 53.7825L25.6104 49.5925L18.7358 43.8075L17.6299 53.7825Z",
    fill: "#E27625"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3896 49.5925L42.3702 53.7825L41.2642 43.8075L34.3896 49.5925Z",
    fill: "#E27625"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3702 53.7825L34.3896 49.5925L35.0249 55.2025L34.9554 57.5625L42.3702 53.7825Z",
    fill: "#D5BFB2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6299 53.7825L25.0447 57.5625L24.9983 55.2025L25.6104 49.5925L17.6299 53.7825Z",
    fill: "#D5BFB2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1869 40.1L18.5488 37.995L23.2323 35.685L25.1869 40.1Z",
    fill: "#233447"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8135 40.1L36.768 35.685L41.4747 37.995L34.8135 40.1Z",
    fill: "#233447"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6308 53.7825L18.7831 43.4775L11.417 43.705L17.6308 53.7825Z",
    fill: "#CC6228"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2178 43.4775L42.3701 53.7825L48.6071 43.705L41.2178 43.4775Z",
    fill: "#CC6228"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8186 32.1325L33.5889 32.7675L34.8131 40.1L36.7676 35.685L41.4743 37.995L46.8186 32.1325Z",
    fill: "#CC6228"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5482 37.995L23.2317 35.685L25.1862 40.1L26.4104 32.7675L13.1807 32.1325L18.5482 37.995Z",
    fill: "#CC6228"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1807 32.1325L18.736 43.8075L18.5482 37.995L13.1807 32.1325Z",
    fill: "#E27525"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4747 37.995L41.2637 43.8075L46.819 32.1325L41.4747 37.995Z",
    fill: "#E27525"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4107 32.7675L25.1865 40.1L26.74 48.755L27.0692 37.36L26.4107 32.7675Z",
    fill: "#E27525"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5894 32.7675L32.9541 37.335L33.2602 48.755L34.8136 40.1L33.5894 32.7675Z",
    fill: "#E27525"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8132 40.1L33.2598 48.755L34.3889 49.5925L41.2635 43.8075L41.4744 37.995L34.8132 40.1Z",
    fill: "#F5841F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5488 37.995L18.7366 43.8075L25.6112 49.5925L26.7403 48.755L25.1869 40.1L18.5488 37.995Z",
    fill: "#F5841F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9542 57.5625L35.0238 55.2025L34.4372 54.645H25.5617L24.9983 55.2025L25.0447 57.5625L17.6299 53.7825L20.2197 56.065L25.4922 60H34.5068L39.7792 56.065L42.369 53.7825L34.9542 57.5625Z",
    fill: "#C0AC9D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3892 49.5925L33.2601 48.755H26.7403L25.6111 49.5925L24.999 55.2025L25.5624 54.645H34.4379L35.0245 55.2025L34.3892 49.5925Z",
    fill: "#161616"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0229 19.975L60.0006 9.62L57.0351 0L34.3896 18.1225L43.1005 26.065L55.4098 29.95L58.1179 26.5225L56.9401 25.61L58.8228 23.755L57.3876 22.5375L59.2702 20.99L58.0229 19.975Z",
    fill: "#763E1A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.62L2.00093 19.975L0.73035 20.99L2.61303 22.5375L1.17783 23.755L3.06051 25.61L1.88268 26.5225L4.59077 29.95L16.9001 26.065L25.6109 18.1225L2.96545 0L0 9.62Z",
    fill: "#763E1A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4093 29.95L43.1 26.065L46.819 32.1325L41.2637 43.8075L48.6066 43.705H59.5294L55.4093 29.95Z",
    fill: "#F5841F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9004 26.065L4.59106 29.95L0.494141 43.705H11.4169L18.7367 43.8075L13.1814 32.1325L16.9004 26.065Z",
    fill: "#F5841F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5892 32.7675L34.3891 18.1225L37.9435 7.69003H22.0566L25.611 18.1225L26.4109 32.7675L26.717 37.385L26.7402 48.755H33.26L33.2832 37.385L33.5892 32.7675Z",
    fill: "#F5841F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.db50ac8a.svg";
export { ForwardRef as ReactComponent };